import React from 'react';

export interface AddressMainTextProps extends React.HTMLProps<HTMLDivElement> {
  text: string;
}

const AddressMainText: React.FC<AddressMainTextProps> = ({
  text,
  ...props
}) => (
  <div
    className={`font-medium text-[1.6rem] leading-[1.8rem] text-[#202020] ${props.className || ''}`}
    {...props}
  >
    {text}
  </div>
);

export default AddressMainText;
